var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEe = function SvgIconEe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 12c0 1.467.264 2.873.746 4.173L12 16.695l11.254-.522c.482-1.3.746-2.706.746-4.174s-.264-2.874-.746-4.174L12 7.304.746 7.825A12 12 0 0 0 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 0C6.84 0 2.442 3.256.746 7.826h22.507C21.558 3.256 17.16 0 12 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M23.253 16.174H.746C2.442 20.744 6.84 24 12 24s9.558-3.256 11.253-7.826"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconEe;